import React from 'react';

export default ({ labelsSeparator }) => {
    return <span style={{ marginRight: '4px' }}>{labelsSeparator}</span>;
}
